module.exports = __webpack_public_path__ + "img/u1204.a1686bca.svg";